import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';
import { ItemEditBtns } from '../../services/itemeditbtns/itemeditbtns';

export const EmailFooterTwo = {
    components: {
        ItemEditBtns
    },
    props: {
        tagClass: String
    },
    methods: {

    },
    computed: {
        ...mapState(vplSiteStore, ['templateData'])
    },
    template: `
        <ItemEditBtns  v-if="templateData && templateData.mail && templateData.mail.EDIT_BUTTON" :onclick="templateData.mail.EDIT_BUTTON">
            Редактировать e-mail
        </ItemEditBtns>
        <a  v-if="templateData && templateData.mail && templateData.mail.CONTENT"
            :href="'mailto:' + templateData.mail.CONTENT" class="contacts-socials__mail js-copymail"
            >
            <span class="footer__contact-icon" aria-hidden="true">
                <svg class="icon" width="18" height="18"><use xlink:href="#footer-mail"></use></svg>
            </span>
            <span class="footer__contact-text">
                <span class="footer__contact-value">{{ templateData.mail.CONTENT }}</span>
                <span class="footer__contact-note">Ответим на все вопросы</span>
            </span>
        </a>
    `
}